import React from 'react';
import { formatNumber } from '../../helpers/formatNumber/formatNumber';
import { DeliveryStatus, OrderRow } from '../../types';
import { Col, Row } from 'antd';
import { DeliveryStatusBadge } from '../deliveryStatusBadge/deliveryStatusBadge';
interface Props {
  rows: OrderRow[];
  currencyPriceDecimalPlaces: number;
  hideUnitPrice?: boolean;
}
export function ArticleRows({
  rows,
  currencyPriceDecimalPlaces,
  hideUnitPrice,
}: Props) {
  return (
    <>
      {rows.map((row, i) => (
        <Row key={i}>
          <Col span={3}>{row.quantityOrdered}</Col>
          <Col span={3}>{GetDeliveryStatus(row)}</Col>
          <Col span={3}>
            <>
              {row.deliveryDates.length > 0
                ? row.deliveryDates.map((deliveryDate, i) => (
                    <div key={i}>{deliveryDate}</div>
                  ))
                : ''}
            </>
          </Col>
          <Col span={3}>{row.batchNo}</Col>
          <Col span={3}>
            {!hideUnitPrice &&
              formatNumber(row.unitPrice, currencyPriceDecimalPlaces)}
          </Col>
          <Col span={3}>{formatNumber(row.totalPrice, 2)}</Col>
          <Col span={3}>{row.rowNumber}</Col>
          <Col span={3}>{row.orderNumber}</Col>
        </Row>
      ))}
    </>
  );
}

function GetDeliveryStatus(row: OrderRow) {
  let deliveryStatus: DeliveryStatus;

  if (row.quantityDelivered >= row.quantityOrdered) {
    deliveryStatus = DeliveryStatus.Delivered;
  } else if (row.quantityDelivered <= 0) {
    deliveryStatus = DeliveryStatus.Undelivered;
  } else {
    deliveryStatus = DeliveryStatus.PartiallyDelivered;
  }

  return (
    <div>
      <span style={{ marginRight: '10px' }}>{row.quantityDelivered}</span>
      <DeliveryStatusBadge deliveryStatus={deliveryStatus} showText={false} />
    </div>
  );
}
